import AlertTypes from 'store/actionTypes/alert'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  systems: [],
  list: [],
  filter: {},
  pagination: {},
  current: {},
  sortBy: 'default'
}

const Alert = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case AlertTypes.GET_SYSTEM_ALERTS_SUCCESS:
      return {
        ...state,
        systems: payload?.items
      }

    case AlertTypes.GET_ALERT_DETAIL_SUCCESS:
      return {
        ...state,
        current: payload || []
      }

    case AlertTypes.UPDATE_FILTER_ALERT_SUCCESS:
      return { ...state, filter: payload }

    case AlertTypes.UPDATE_ORDER_BY_ALERT_SUCCESS:
      return { ...state, sortBy: payload }

    case AlertTypes.GET_ALERTS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default Alert
